import { ShieldCheck, AlertTriangle, ShieldAlert, Users, ChefHat, Timer, Flame } from "lucide-react";
import { fmt } from "./analyticsUtils";

const configs = {
  healthy: {
    icon: ShieldCheck, color: "text-emerald-600", bg: "bg-emerald-50", border: "border-emerald-200",
    label: "Operação Normal", desc: "Todos os indicadores estão saudáveis",
  },
  warning: {
    icon: AlertTriangle, color: "text-amber-600", bg: "bg-amber-50", border: "border-amber-200",
    label: "Atenção Necessária", desc: "Alguns indicadores precisam de atenção",
  },
  critical: {
    icon: ShieldAlert, color: "text-red-600", bg: "bg-red-50", border: "border-red-200",
    label: "Ação Imediata", desc: "Problemas críticos detectados",
  },
};

export function OperationStatus({ status, current }) {
  const cfg = configs[status] || configs.healthy;
  const Icon = cfg.icon;

  return (
    <div className={`rounded-2xl p-5 border-2 ${cfg.bg} ${cfg.border}`} data-testid="operation-status">
      <div className="flex items-center gap-3 mb-4">
        <div className={`p-3 rounded-xl ${cfg.bg}`}>
          <Icon className={`w-8 h-8 ${cfg.color}`} />
        </div>
        <div>
          <h3 className={`text-lg font-bold ${cfg.color}`}>{cfg.label}</h3>
          <p className="text-sm text-gray-500">{cfg.desc}</p>
        </div>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        <div className="bg-white rounded-xl p-3 text-center shadow-sm">
          <Users className="w-5 h-5 mx-auto text-blue-500 mb-1" />
          <p className="text-2xl font-bold text-gray-800">{current?.in_queue || 0}</p>
          <p className="text-xs text-gray-500">Na fila</p>
        </div>
        <div className="bg-white rounded-xl p-3 text-center shadow-sm">
          <ChefHat className="w-5 h-5 mx-auto text-emerald-500 mb-1" />
          <p className="text-2xl font-bold text-gray-800">{current?.in_prep || 0}</p>
          <p className="text-xs text-gray-500">Preparando</p>
        </div>
        <div className="bg-white rounded-xl p-3 text-center shadow-sm">
          <Timer className="w-5 h-5 mx-auto text-amber-500 mb-1" />
          <p className="text-2xl font-bold text-gray-800">{fmt(current?.avg_queue_min)}</p>
          <p className="text-xs text-gray-500">Espera média</p>
        </div>
        <div className="bg-white rounded-xl p-3 text-center shadow-sm">
          <Flame className="w-5 h-5 mx-auto text-orange-500 mb-1" />
          <p className="text-2xl font-bold text-gray-800">{fmt(current?.avg_prep_min)}</p>
          <p className="text-xs text-gray-500">Preparo médio</p>
        </div>
      </div>
    </div>
  );
}
